import React, { useEffect } from "react";
import school from "../../assets/mycenter.jpg";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, appConstants } from "../../AtomStore/store";
import { FaMobileScreen } from "react-icons/fa6";
import {
  fetchCenters,
  fetchTeachersData,
} from "../../QueryFunctions/queryfunction";

import MyCenterItem from "./Item";
import ImageComponent from "../../Layout/LoggedInLayout/ImageComponent";
import { IoMail } from "react-icons/io5";

const MyCenterMobile = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [activeChild] = useAtom(activeChildDetail);
  const [constants] = useAtom(appConstants);
  const { data: fetchTeachers, isLoading } = useQueryWrapper(
    ["fetchTeachers", activeChild?.id],
    () => {
      console.log("[My Center] Calling API: /userauth/listUsersInRole", {
        child_id: activeChild?.id,
      });
      return fetchTeachersData();
    },
    {
      onSuccess: (data) => {
        console.log("[My Center] Get teachers data response:", data);
      },
    }
  );
  const { data: Centers, isFetching } = useQueryWrapper(
    ["Centers", activeChild?.id],
    () => {
      console.log("[My Center] Calling API: /parentapp/getCenterJSON", {
        child_id: activeChild?.id,
      });

      return fetchCenters();
    },
    {
      onSuccess: (data) => {
        console.log("[My Center] Get Centers data response:", data);
      },
    }
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  console.log("centers data ", Centers);
  return (
    <div className={`mb-6 ${isLoading || isFetching ? "animate-pulse" : ""}`}>
      <div
        className="h-30 bg-center bg-cover "
        style={{ backgroundImage: `url("${school}")` }}
      >
        <h3 className="text-white font-bold text-center text-lg w-full h-full flex  items-center justify-center bg-black bg-opacity-50">
          {isLoading || isFetching ? (
            <div className="h-5 w-50  bg-slate-200 rounded"></div>
          ) : Centers ? (
            `${Centers.Center_Name},${Centers.Center_City}`
          ) : (
            ""
          )}
        </h3>
      </div>
      <h2 className="text-xl font-bold col-span-12 text-center mt-2">
        Center Head
      </h2>
      {isLoading || isFetching ? (
        <div className="grid grid-cols-12 gap-2 m-3 bg-white p-2 rounded-sm animate-pulse">
          <div className="col-span-4 md:col-span-12 flex justify-center items-center">
            <div className="md:h-40 md:w-40 lg:h-60 lg:w-60 bg-gray-300 rounded-lg" />
          </div>

          <div className="col-span-8 md:col-span-12 text-start">
            <div className="h-6 bg-gray-300 rounded w-48 mb-2 md:mx-auto" />
          </div>
        </div>
      ) : Centers?.Center_Head_Name ? (
        <div className="grid grid-cols-12 gap-2 m-3 bg-white p-2 rounded-sm">
          <div className="col-span-4 md:col-span-12 flex justify-center items-center">
            <div className=" md:h-40 md:w-40 lg:h-60 lg:w-60 ">
              <ImageComponent
                className={`rounded-lg object-cover`}
                src={constants?.teachersPath + Centers?.Center_Head_Photo}
                alt="teacher"
                profile={false}
              />
            </div>
          </div>

          <div className=" col-span-8 md:col-span-12 text-start">
            <h2 className="text-lg font-semibold text-start md:text-center p-1 pl-2 rounded-full flex md:justify-center ">
              {" "}
              {isLoading || isFetching ? (
                <div className="m-1 h-4 w-30  bg-slate-200 rounded"></div>
              ) : (
                Centers?.Center_Head_Name
              )}
            </h2>
            <h2 className=" text-base  md:text-center p-1 pl-2 rounded-full  flex items-center  md:justify-center">
              {isLoading || isFetching ? (
                <div className="text-sm space-y-1 animate-pulse">
                  <span className="flex items-start gap-2">
                    <div className="w-4 h-4 bg-gray-300 rounded mt-1" />
                    <div className="h-4 bg-gray-300 rounded w-48" />
                  </span>
                  <span className="flex items-start gap-2">
                    <div className="w-4 h-4 bg-gray-300 rounded mt-0.5" />
                    <div className="h-4 bg-gray-300 rounded w-32" />
                  </span>
                </div>
              ) : Centers?.Center_Head_Contact ? (
                <div className="text-sm space-y-1">
                  <span className="flex items-start gap-2 break-words">
                    <IoMail className="mt-1" />
                    <span className="break-all">
                      {Centers?.Center_Head_Email}
                    </span>
                  </span>
                  <span className="flex items-start gap-2">
                    <FaMobileScreen className="mt-0.5" />
                    <span>{Centers?.Center_Head_Contact}</span>
                  </span>
                </div>
              ) : (
                <></>
              )}
            </h2>
          </div>
        </div>
      ) : (
        <div className="py-10 px-3 bg-white  rounded-sm m-3">
          <h2> Center head information is not available right now</h2>
        </div>
      )}

      <div className="grid grid-cols-12 gap-x-3 gap-y-3 mx-3 mt-3">
        {fetchTeachers?.map((item, index) => (
          <MyCenterItem key={index} item={item} index={index} />
        ))}
      </div>
    </div>
  );
};

export default MyCenterMobile;
